/**
 * Client-side gap ordering helper. Mirrors the server's STEP
 * (api/services/ProjectOrderingService.js). The client computes the integer
 * midpoint between a card's two new neighbours, so a drop writes ONE row. When
 * the gap collapses the midpoint collides and the server rebalances that column,
 * returning canonical orders for the client to reconcile.
 */
export const ORDER_STEP = 65536;

export function computeOrderBetween(
  prevOrder: number | null | undefined,
  nextOrder: number | null | undefined
): number {
  const hasPrev = prevOrder !== null && prevOrder !== undefined;
  const hasNext = nextOrder !== null && nextOrder !== undefined;
  if (!hasPrev && !hasNext) return ORDER_STEP;
  if (!hasPrev) return Math.floor((nextOrder as number) - ORDER_STEP);
  if (!hasNext) return Math.floor((prevOrder as number) + ORDER_STEP);
  return Math.floor(((prevOrder as number) + (nextOrder as number)) / 2);
}
